import { HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { DelegationService } from '@app/_services/delegation.service';
import { Observable } from 'rxjs';
import { first, mergeMap } from 'rxjs/operators';

@Injectable()
export class DelegationInterceptor implements HttpInterceptor {
  private readonly delegationService = inject(DelegationService);

  static readonly skipDelegatorInterceptor = new HttpContextToken<boolean>(() => false);
  static delegatorUserIdRequestParam = 'delegatorUserId';

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.isExternalRequest(req) || req.context.get(DelegationInterceptor.skipDelegatorInterceptor)) {
      return next.handle(req);
    }

    return this.delegationService.delegator$.pipe(
      first(),
      mergeMap((delegatorOrUndefined) => {
        if (delegatorOrUndefined?.userId) {
          const changedReq = req.clone({
            params: req.params.set(DelegationInterceptor.delegatorUserIdRequestParam, delegatorOrUndefined.userId),
          });
          return next.handle(changedReq);
        } else {
          return next.handle(req);
        }
      }),
    );
  }

  /**
   * Check if this is an "external" request (request with an absolute url, e.g. to the IdP Keycloak).
   * We don't want to add the delegatorUserId to those.
   */
  private isExternalRequest(req: HttpRequest<unknown>) {
    return !req.url?.startsWith('/');
  }
}
